import { Routes } from '@angular/router';
import { Home } from './pages/home/home';
import { Test } from './pages/test/test';

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'home', component: Home },
  { path: 'test', component: Test },
  // There was no fallback, so an unknown path rendered an empty outlet.
  { path: '**', component: Home },
];
